<div class="snackbar snackbar-{{ data.type }}">
    @if (data.type === 'success') {
        <svg class="snackbar-check" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" rx="4" fill="#008800"/><path d="M4.5 9.5L7.5 12.5L13.5 5.5" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
    }
    <span class="snackbar-message">{{ data.message }}</span>
    @if (data.type !== 'success') {
        <button type="button" class="snackbar-close" (click)="onClose()">×</button>
    }
</div>
